module.exports = __webpack_public_path__ + "static/media/london-logo.4eec290d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/london-logo.svg
// module id = 117
// module chunks = 0